"use client";
import s from "./ArticleSidebar.module.scss";
import React from "react";
import { ArticleCategories, ArticleCategoriesProps } from "./ArticleCategories";

export type ArticleSidebarProps = {
  categoriesData: ArticleCategoriesProps;
};

export const ArticleSidebar = ({ categoriesData }: ArticleSidebarProps) => {
  return (
    <div className={s.wrapper}>
      <ArticleCategories {...categoriesData} />
    </div>
  );
};
